import React from 'react';

import { Row, Col } from 'components/layout';

import Feedback from '../Feedback';

import waitingContainerImg from '../../assets/images/waitingContainer.svg';
import { labelsByVariant } from 'views/Btc/constants';

const WaitingInfoView = ({ variant }) => (
  <Row justify="center" align="middle" style={{ height: '100%' }}>
    <Col style={{ textAlign: 'center' }}>
      <Feedback
        title={labelsByVariant[variant].waitingInfoTitle}
        img={<img src={waitingContainerImg} alt={labelsByVariant[variant].waitingInfoTitle} />}
        styles={{
          img: { height: '17vh' },
          title: { fontSize: '6vw' }
        }}
      />
    </Col>
  </Row>
);

export default WaitingInfoView;